const getThemeUnwrapped = (theme) => {
  return (theme == null ? void 0 : theme[GetThemeUnwrapped]) || theme;
};
const GetThemeUnwrapped = Symbol();
export {
  GetThemeUnwrapped,
  getThemeUnwrapped
};
//# sourceMappingURL=getThemeUnwrapped.js.map
